import {filterBy, FilterDescriptor} from "@progress/kendo-data-query"
import {Button} from "@progress/kendo-react-buttons"
import {
    ComboBoxChangeEvent,
    ListItemProps,
    MultiColumnComboBox,
    MultiColumnComboBoxHandle,
} from "@progress/kendo-react-dropdowns"
import {useInternationalization} from "@progress/kendo-react-intl"
import {Card, CardActions, CardBody} from "@progress/kendo-react-layout"
import {MDBCol, MDBRow} from "mdbreact"
import React from "react"
import {TestCosts} from "../../containers/DvsaTest/dvsatestsSlice"
import {setTestPackageTests} from "../../containers/Fees/feesSlice"
import {RootState} from "../../rootReducer"
import {SpinnerGrid} from "../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../store"
import {hasPermission} from "../Shared/permissionChecker"

const columns = [
    {field: "code", header: "Code"},
    {field: "test", header: "Test"},
    {field: "testType", header: "Test Type"},
    {field: "axle", header: "Axle"},
    {field: "duration", header: "Duration", width: "90px"},
    {field: "charges", header: "Test Fee", width: "90px"},
]
type Props = {
    isError?: boolean
}
const DvsaTestCharges = (props: Props) => {
    const dispatch = useAppDispatch()
    const intl = useInternationalization()

    const testCostData = useAppSelector((state: RootState) => state.containers.dvsaTest.testCostsData)
    const dvsatestChargesLoding = useAppSelector((state: RootState) => state.containers.dvsaTest.testCostsLoading)
    const testPackageTests = useAppSelector((state: RootState) => state.containers.fees.testPackageTests)
    const testPackageDetails = useAppSelector((state: RootState) => state.containers.fees.testPackageDetails)
    const assignedPermissions = useAppSelector((state: RootState) => state.application.permissions)

    const verifyPermissionDelete: boolean = hasPermission(["TestPackages.Delete"], assignedPermissions)

    const [filter, setFilter] = React.useState<FilterDescriptor>()
    const [selectedTest, setSelectedTest] = React.useState(null)

    const removeTestClick = (testCodeId: number) => {
        dispatch(setTestPackageTests(testPackageTests.filter(d => d !== testCodeId)))
    }

    const addTest = (event: ComboBoxChangeEvent) => {
        if (multiComboEl.current) {
            const item = multiComboEl.current.value as TestCosts
            if (!testPackageTests.find(d => d === item.dvsaTestCostID) && event.syntheticEvent.type !== "keydown") {
                dispatch(setTestPackageTests([...testPackageTests, item.dvsaTestCostID]))
            }
        }
        if (event) setSelectedTest(event.target.value)
    }

    const formattedTestCost = (tp: any): React.ReactNode => {
        const testCost = testCostData.find(t => t.dvsaTestCostID === tp)
        return intl.formatNumber(testCost?.charges === undefined ? 0 : testCost?.charges, {
            style: "currency",
            minimumFractionDigits: 2,
        })
    }

    const MultiColumnComboBoxRender = (
        li: React.ReactElement<HTMLLIElement, string | React.JSXElementConstructor<any>>,
        props: ListItemProps,
    ) => {
        const children = columns.map((col: any, i) => (
            <span className="k-table-td" style={{width: col.width}} key={crypto.randomUUID()}>
                {intl.formatNumber(
                    props.dataItem[col.field],
                    col.field === "charges" ? {style: "currency", minimumFractionDigits: 2} : "",
                )}
            </span>
        ))

        return React.cloneElement(li, {...li.props}, children)
    }

    const multiComboEl = React.createRef<MultiColumnComboBoxHandle>()

    const calculateContainerHeight = (): number => {
        if (
            (verifyPermissionDelete && hasPermission(["TestPackages.Add"], assignedPermissions)) ||
            (hasPermission(["TestPackages.Add"], assignedPermissions) &&
                hasPermission(["TestPackages.Edit"], assignedPermissions))
        )
            return 30
        return 27
    }

    return (
        <div>
            {dvsatestChargesLoding && <SpinnerGrid />}
            <MDBRow>
                <span className="k-floating-label-container">
                    <MDBRow className="mb-3">
                        <MDBCol>
                            <MultiColumnComboBox
                                name="dvsaTestsComboBox"
                                ref={multiComboEl}
                                data={
                                    filter
                                        ? filterBy(
                                              testCostData.filter(
                                                  td =>
                                                      testPackageTests.filter(tpt => td.dvsaTestCostID === tpt)
                                                          .length === 0,
                                              ),
                                              filter,
                                          )
                                        : testCostData.filter(
                                              td =>
                                                  testPackageTests.filter(tpt => td.dvsaTestCostID === tpt).length ===
                                                  0,
                                          )
                                }
                                onChange={addTest}
                                columns={columns}
                                textField={"code"}
                                filterable={true}
                                value={selectedTest}
                                onFilterChange={event => event && setFilter(event.filter)}
                                itemRender={MultiColumnComboBoxRender}
                                popupSettings={{height: "325px"}}
                            />
                        </MDBCol>
                    </MDBRow>
                    <label className={props.isError ? "k-text-error k-label" : "k-label"} htmlFor="dvsaTestsComboBox">
                        Available DVSA Tests
                    </label>
                </span>
            </MDBRow>
            {testPackageTests.length > 0 && (
                <MDBRow>
                    <label className="k-label mt-1 mb-2" htmlFor="selectedTestList">
                        Selected DVSA Tests
                    </label>
                </MDBRow>
            )}
            <MDBRow
                className="pe-2"
                style={{
                    height: `calc(100vh - ${calculateContainerHeight()}.8rem)`,
                    overflowX: "hidden",
                }}
                name="selectedTestList"
            >
                {testPackageTests.map(tp => (
                    <>
                        <MDBCol md="3" className="mb-3 pt-1 pe-0 pt-0">
                            <Card>
                                <CardBody className="pb-0">
                                    <h6>{testCostData.find(t => t.dvsaTestCostID === tp)?.code}</h6>
                                    <p>
                                        {testCostData.find(t => t.dvsaTestCostID === tp)?.test}
                                        <hr />
                                    </p>

                                    <MDBRow>
                                        <MDBCol md="6">Axle</MDBCol>
                                        <MDBCol md="6">{testCostData.find(t => t.dvsaTestCostID === tp)?.axle}</MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="6">Duration</MDBCol>
                                        <MDBCol md="6">
                                            {testCostData.find(t => t.dvsaTestCostID === tp)?.duration} min
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="6">Test Fee</MDBCol>
                                        <MDBCol md="6">{formattedTestCost(tp)}</MDBCol>
                                    </MDBRow>
                                    <MDBRow className="pt-3">
                                        <MDBCol md="12">
                                            {testCostData.find(t => t.dvsaTestCostID === tp)?.testType}
                                            <hr className="mt-3 mb-0" />
                                        </MDBCol>
                                    </MDBRow>
                                </CardBody>
                                <CardActions>
                                    <Button
                                        fillMode="flat"
                                        themeColor={"primary"}
                                        className="buttons-container-button"
                                        onClick={() => removeTestClick(tp)}
                                        disabled={
                                            testPackageDetails.testPackageID === undefined
                                                ? false
                                                : testPackageTests.length === 1 || !verifyPermissionDelete
                                        }
                                    >
                                        Remove
                                    </Button>
                                </CardActions>
                            </Card>
                        </MDBCol>
                    </>
                ))}
            </MDBRow>
        </div>
    )
}

export default DvsaTestCharges
